// extracted by mini-css-extract-plugin
export default {"menu":"directions_menu__3gJOf","search":"directions_search__wjh37"};